import { useQuery } from '@tanstack/react-query';
import { GeolocationService } from '../service/geolocation';

const service = new GeolocationService();


export function useGeolocationPlace(lat: number, lon: number) {
  const { data: locationData, isLoading, error } = useQuery({
    queryKey: ['geolocationPlace', lat, lon],
    queryFn: async () => {
      const res = await service.getLocationFromCoords({ lat, lon });
      return res.dados;
    },
    enabled: !!lat && !!lon,
    staleTime: 1000 * 60 * 60 * 24 * 30, // Cache de 30 dias
  });

  return { locationData, isLoading, error };
}